import React, { useContext as useContextCore } from 'react'

export type ShortcutConfig = {
  id: string
  keys: string // empty string '' means unbound
  label: string
  category: string
}

export type ShortcutDefinition = ShortcutConfig & {
  action: () => void
  enabled?: boolean
}

export type KeyboardShortcutContextType = {
  shortcuts: Map<string, ShortcutDefinition>
  userBindings: Record<string, string> // id -> key combo from AppSettings
  // `registrant` tells co-mounted registrants of one id apart; omitted, they all share one slot.
  registerShortcut: (shortcut: ShortcutDefinition, registrant?: string) => void
  unregisterShortcut: (id: string, registrant?: string) => void
  updateBinding: (id: string, keys: string) => Promise<void>
  removeBinding: (id: string) => Promise<void>
  reassignBinding: (fromId: string, toId: string, keys: string) => Promise<void>
  clearAllBindings: () => Promise<void>
  getResolvedKeys: (id: string) => string // returns user binding or '' if unbound
  setPaused: (paused: boolean) => void
  loading: boolean
}

const context = React.createContext<KeyboardShortcutContextType>({} as KeyboardShortcutContextType)

export const KeyboardShortcutContext = context

export const useKeyboardShortcutContext = () => useContextCore(context)
